export enum SessionEndpointsEnum {
  CLASSES = "class-type/:classId",
  CLASSES_FEEDBACK = "class-type/:classId/feedbacks",
  SESSIONS = "video/sessions/:sessionId",
  TOKENS = "video/sessions/:sessionId/tokens",
  FORCE_DISCONNECT = "video/sessions/:sessionId/forceDisconnect",
}
